import { render, staticRenderFns } from "./menuServiceData.vue?vue&type=template&id=c6ce8568&scoped=true"
import script from "./menuServiceData.vue?vue&type=script&lang=js"
export * from "./menuServiceData.vue?vue&type=script&lang=js"
import style0 from "./menuServiceData.vue?vue&type=style&index=0&id=c6ce8568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce8568",
  null
  
)

export default component.exports